import React, {useCallback, useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper";
import {useDispatch, useSelector} from "react-redux";
import {Helmet} from "react-helmet";
import {forward, input, short, sip} from "../translate";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import TableBody from "@mui/material/TableBody";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDownWideShort, faArrowUpShortWide, faPenToSquare, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import {Link, useLocation, useNavigate} from "react-router-dom";
import TablePagination from "@mui/material/TablePagination";
import AddAndEditForward from "../components/AddAndEditForward";
import SearchIcon from "@mui/icons-material/Search";
import {forwardDeleteLocal, forwardRequest,} from "../store/actions/forward";
import qs from "query-string";
import Api from "../Api";
import Utils from "../Utils";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {sipProviderLocalDelete} from "../store/actions/sip";
import Cookies from "js-cookie";

const {REACT_APP_SERVER} = process.env;
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

function Forward(props) {
    const forwardData = useSelector(state => state.forward.forwardData)
    const count = useSelector(state => state.forward.count)
    const page = useSelector(state => state.forward.page)
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const [edit, setEdit] = useState(0)
    const [create, setCreate] = useState(false)
    const [copied, setCopied] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const handleDelete = useCallback(async (id) => {
        try {
            let text = +localStorage.getItem('atsLang') === 1 ? "Are you sure you want to delete?" :
                +localStorage.getItem('atsLang') === 2 ? "Вы уверены, что хотите судалить?" :
                    "Վստա՞հ եք, որ ցանկանում եք ջնջել";

            if (confirm(text) === true) {
                await dispatch(forwardDeleteLocal(id))
                try {
                    await Api.deleteForward(id)

                } catch (e) {
                }
            }
        } catch (e) {
            console.log(e)
        }
    }, [])
    const [sortBy, setSortBy] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    useEffect(() => {
        (async () => {
            await dispatch(forwardRequest(Cookies.get("forward") || query.limit || 10, query.page || 1, query.search || '',query.sortBy || '', query.sortOrder || ''))
        })()
    }, [location.search])
    const handleChangePage = useCallback((page) => {
        query.page = page + 1
        navigate(`?${qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
    }, [location.search])

    const handleSearch = useCallback((ev) => {
        query.search = ev.target.value
        navigate(`?${qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
    }, [])
    const handleLimit = useCallback((page) => {
        query.limit = page
        query.page = '1'
        Cookies.set("forward", page, { expires: 30 })

        navigate(`?${qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
    }, [location.search])
    const handleSort = (column) => {
        query.sortBy = column
        if (sortBy === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
            query.sortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
            navigate(`?${qs.stringify(query, {
                arrayFormat: 'comma',
                skipEmptyString: true,
            })}`);
        } else {
            setSortBy(column);
            setSortOrder('asc');
            query.sortOrder = 'asc'
            navigate(`?${qs.stringify(query, {
                arrayFormat: 'comma',
                skipEmptyString: true,
            })}`);
        }
    };
    return (
        <>
            <Helmet>
                <title>
                    {forward.forward[+localStorage.getItem('atsLang') || 1]}
                </title>
            </Helmet>
            <Wrapper>
                <div className="tableParent">
                    <Paper sx={{minWidth: 'fit-content', fontSize: 10}}>
                        <TableContainer
                        >
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow className="sip_header">
                                        <TableCell sx={{fontSize: 20,}} align="left" colSpan={2}>
                                            {forward.forward[+localStorage.getItem('atsLang') || 1]}
                                        </TableCell>
                                        <TableCell sx={{fontSize: 15,}} align="right" colSpan={6}>
                                            <span className="d-flex justify-content-end">
                                                <label className="search">
                                                    <input
                                                        value={query.search || ''}
                                                        onChange={handleSearch}
                                                        placeholder={input.search[+localStorage.getItem('atsLang') || 1]}/>
                                                    <span className="search_cover" style={isSearch ? {top: 0} : {}}/>
                                                </label>
                                                <span style={{margin: '0 10px'}} className="add"
                                                      onClick={() => setIsSearch(!isSearch)}>
                                                <SearchIcon/>
                                            </span>
                                                <span className="add" onClick={() => setCreate(true)}>
                                                <AddCircleOutlineIcon/>
                                            </span>
                                            </span>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow className="sip_num">
                                        <TableCell
                                            align='center'
                                        />
                                        <TableCell
                                            onClick={() => handleSort('input')}
                                            align='center'
                                        >
                                            {sip.phone[+localStorage.getItem('atsLang') || 1]}
                                            <span>{sortBy === 'input' && sortOrder === 'asc' ?
                                                <FontAwesomeIcon icon={faArrowUpShortWide}/> :
                                                <FontAwesomeIcon icon={faArrowDownWideShort}/>}</span>
                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            {sip.note[+localStorage.getItem('atsLang') || 1]}

                                        </TableCell>
                                        <TableCell
                                            onClick={() => handleSort('output')}
                                            align='center'
                                        >
                                            {sip.forward[+localStorage.getItem('atsLang') || 1]}
                                            <span>{sortBy === 'output' && sortOrder === 'asc' ?
                                                <FontAwesomeIcon icon={faArrowUpShortWide}/> :
                                                <FontAwesomeIcon icon={faArrowDownWideShort}/>}</span>
                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            {sip.action[+localStorage.getItem('atsLang') || 1]}
                                        </TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {forwardData.length ? forwardData.map(s => (
                                        <TableRow key={s.id} hover role="checkbox" tabIndex={-1}>
                                            <TableCell align="center">
                                                <CheckCircleIcon style={{color: color}}/>
                                            </TableCell>
                                            <TableCell align="center">
                                                {s.input}
                                            </TableCell>
                                            <TableCell align="center">
                                                {s.buddies_notes || s.dids_notes || s.regs_notes}
                                            </TableCell>
                                            <TableCell align="center">
                                                {s.output}

                                            </TableCell>
                                            <TableCell className="action" align="center"
                                                       sx={{display: "flex", justifyContent: 'center'}}>
                                                <span onClick={() => setEdit(s.id)} className="edit"><FontAwesomeIcon
                                                    icon={faPenToSquare}/></span>
                                                <span onClick={() => handleDelete(s.id)}
                                                      className="delete"><FontAwesomeIcon icon={faTrashCan}/></span>
                                            </TableCell>

                                        </TableRow>

                                    )) : <TableRow hover role="checkbox" tabIndex={-1}>

                                        <TableCell align="center" colSpan={5} sx={{fontSize: 13}}>
                                            no data

                                        </TableCell>
                                    </TableRow>
                                    }
                                    {/*    );*/}
                                    {/*})}*/}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="foot_footer d-flex align-items-center justify-content-end">
                            <Link style={{margin: '0 10px'}} onClick={() => Utils.dataToExel([
                                sip.phone[+localStorage.getItem('atsLang') || 1],
                                sip.note[+localStorage.getItem('atsLang') || 1],
                                sip.forward[+localStorage.getItem('atsLang') || 1],
                            ], forwardData)}>Excel</Link>
                            <Link style={{margin: '0 10px'}} onClick={() => window.print()}>Print</Link>
                            <Link style={{margin: '0 10px'}} onClick={() => Utils.dataToExel([
                                sip.phone[+localStorage.getItem('atsLang') || 1],
                                sip.note[+localStorage.getItem('atsLang') || 1],
                                sip.forward[+localStorage.getItem('atsLang') || 1],
                            ], forwardData)}>CSV</Link>
                            <Link style={{margin: '0 10px'}} onClick={() => {
                                let table = document.getElementById('dataBody');
                                if (navigator.clipboard) {
                                    setCopied(true)
                                    let text = table.innerText.trim();
                                    navigator.clipboard.writeText(text).catch(function () {
                                    });
                                    setTimeout(() => {
                                        setCopied(false)
                                    }, 1000)
                                }
                            }}>COPY</Link>
                            <TablePagination
                                className="hello"
                                rowsPerPageOptions={[10, 25, 100, {label: 'All', value: -1}]}
                                component="div"
                                count={count || 0}
                                rowsPerPage={Cookies.get("forward") || query.limit || 10}
                                page={page - 1 || 0}
                                onPageChange={(event, newPage) => handleChangePage(newPage)}
                                onRowsPerPageChange={(event, newPage) => handleLimit(newPage.props.value)}
                            />
                        </div>
                        {copied ? <div className="copied">Copied</div> : null}

                    </Paper>

                </div>
                {create ? <AddAndEditForward open={create} edit={false} setOpen={setCreate}/> : null}
                {edit ? <AddAndEditForward open={edit} edit={edit} setOpen={setEdit}/> : null}
            </Wrapper>
        </>

    );
}

export default Forward;
